import { SiteMapsEndpoints } from "shared/models/endpoits/sitemap-files.endpoint";
import { getRequest } from "./base-services.request";

export const getAllSiteMap = async () => {
  return getRequest(SiteMapsEndpoints.allSiteMap);
};

export const getFileSiteMap = async (fileName: string) => {
  return getRequest(SiteMapsEndpoints.siteMapFile, {
    fileName,
  });
};
